<div class="page">
  <div class="container">
    <div class="icon-container">
      <!-- TODO: use icon library -->
      <svg
        class="lock-icon"
        viewBox="0 0 24 24"
      >
        <path
          d="M18,8h-1V6c0-2.76-2.24-5-5-5S7,3.24,7,6v2H6c-1.1,0-2,0.9-2,2v10c0,1.1,0.9,2,2,2h12c1.1,0,2-0.9,2-2V10C20,8.9,19.1,8,18,8z M12,17c-1.1,0-2-0.9-2-2s0.9-2,2-2s2,0.9,2,2S13.1,17,12,17z M15.1,8H8.9V6c0-1.71,1.39-3.1,3.1-3.1s3.1,1.39,3.1,3.1V8z"
        />
      </svg>
    </div>

    <h1>No Access</h1>
    <div class="subtitle">
      We want to show you all the wonderful features of Attain Apps, but we
      can't
    </div>

    <div class="description">
      This may be a temporary issue while your account is being set up or the
      platform is being updated. Try waiting a few minutes and then refreshing
      the page. If the issue persists, please contact your Attain Apps
      administrator.
    </div>

    <div class="action-buttons">
      <div
        class="btn btn-primary"
        (click)="refresh()"
      >
        Refresh
      </div>
    </div>

    <div class="contact-info">
      Need help? Contact your Attain Apps administrator.
    </div>
  </div>
</div>
